(ns iris.logs.views
  (:require
   [re-frame.core :as re-frame]
   [reagent.core :as r]
   [iris.subs :as subs]
   [iris.hench :as hench]

   [iris.posts.subs :as posts-subs]

   [iris.logs.subs :as logs-subs]
   [iris.logs.events :as logs-events]
   [iris.common :as common]

   [iris.posts.views.posts-logs-switch :refer [posts-logs-switch]]
   [iris.logs.views.breadcrumbs :refer [breadcrumbs]]
   [iris.logs.views.activity :refer [activity-btns activity-table]]
   [iris.logs.views.pager :refer [pager]]
   [iris.logs.views.header :refer [header-btns]]
   [iris.logs.views.user :refer [user-btns]]
   [iris.logs.views.ip :refer [ip-btns]]
   [iris.logs.views.eid :refer [eid-btns]]
   [iris.logs.views.post :refer [post-data post-actions screening-badge]]

   [shadow.css :refer [css]]
   ))

(defn logs-panel []
  ;; TODO: for now we'll use "ws" and "limit" from posts. maybe those should be moved from under posts or setup logs with their own ws or limit (I think limit could be useful for logs to have its own, ws not so sure)
  (r/with-let [query-params (re-frame/subscribe [::subs/query-params])
               last-qp      (r/atom nil)
               _            (re-frame/dispatch [::logs-events/load-logs-dashboard])]
    (let [qp (select-keys @query-params [:page :activity])]
      (when (not= qp @last-qp)
        (reset! last-qp qp)
        (re-frame/dispatch [::logs-events/sync-logs-query @query-params])))
    [:<>
     [common/admin-top-bar]
     [common/navbar]
     ;;  [personal-moderator-logs]

     [:<>
      [posts-logs-switch]
      [common/spinner]
      [:div
       {:class (css "container" {:width "auto !important"}) :id "page-body"}
       ;; {:class (css :mx-8)}
       [breadcrumbs]
       [:h1 "Logs Dashboard"]
       [activity-btns nil {:activities ["all" "post" "screen" "view" "admin"]}]
       [:div
        [:h2 (str (clojure.string/capitalize @(re-frame/subscribe [::logs-subs/activity])) " activity")]
        [pager]
        [activity-table]
        [pager]]]
      [common/message ::subs/message]]]))

(defn logs-search-panel []

  (let [route-params (re-frame/subscribe [::subs/route-params])
        ;; query-params (re-frame/subscribe [::subs/query-params])
        query-params (re-frame/subscribe [::posts-subs/query-params])]

    [:<>
     [common/admin-top-bar]
     [common/navbar]
        ;;  [personal-moderator-logs]
     [:<>
      [posts-logs-switch]
      [:div
       {:class "container" :id "page-body"}
       [:nav
        {:aria-label "breadcrumb"}
        [:ol
         {:class "breadcrumb"}
         [:li {:class "breadcrumb-item"} [:a {:href "/"} "Athena"]]
         [:li {:class "breadcrumb-item"} "Search"]]]
       [:h1 "Admin Header Search"]
       [:div
        {:style {:margin "30px 0 50px"}}
        [:form
         {:action "/search" :method "get" :class "form-inline mr-auto"}
         [:input
          {:type "text"
           :name "q"
           :id "q"
           :value ""
           :size "60"
           :class "form-control"}]
         [:select
          {:class "form-control" :id "ws" :name "ws"}
          [:option {:value "TLO" :selected ""} "TLO"]
          [:option {:value "TSC"} "TSC"]
          [:option {:value "STK"} "STK"]]
         [:input
          {:type "submit" :value "Search" :class "btn btn-primary"}]]]
       [:h3 {:id "fields"} "Field operators"]
       [:pre
        "slug:        Text    Heder slug\n  alias:       Atom    Shortened slug\n  parent:      Atom    Parent header slug\n  genus:       Atom    Genus, i.e. kind of header: forum, cat, geo, ticker\n  title:       Text    Header title/name\n  descr:       Text    Header description\n  tag:         Atom    Tag, e.g. `tag:education`\n  ticker:      Atom    Ticker symbol, e.g. `ticker:goog`\n  exchange:    Atom    Stock exchange code, e.g. `exchange:xnys`, `exchange:xnas`\n  ncats:       Number  Number of categories\n  ngeos:       Number  Number of geographies\n  ntags:       Number  Number of tags\n  nrels:       Number  Number of related headers\n  ntickers:    Number  Number of tickers\n  can_post:    Atom    yes|no (also works: y|n, true|false, t|f, 1|0)\n  published:   Atom    yes|no (also works: y|n, true|false, t|f, 1|0)\n  is_redirect: Atom    yes|no (also works: y|n, true|false, t|f, 1|0)\n  redirects_to: Atom   Slug where header redirects to (if is_redirect=y)\n  html:        Html    Rendered html\n  created_on:  Date    ISO-style date, e.g. 2019-12-31\n  updated_on:  Date    ISO-style date, e.g. 2019-12-31\n  created_by:  Atom    User ID, e.g. `created_by:lejla`, `created_by:sarajevo@gmail.com`\n  updated_by:  Atom    User ID, e.g. `created_by:lejla`, `created_by:sarajevo@gmail.com`\n  inotes:      Text    Internal notes\n  irefs:       Atom    Internal refs (parsed from inotes)\n  nirefs:      Number  Number of internal references (parsed from inotes)"]]]]))


(defn logs-header-panel []
  (r/with-let [route-params (re-frame/subscribe [::subs/route-params])
               query-params (re-frame/subscribe [::subs/query-params])
               last-qp      (r/atom nil)
               _            (re-frame/dispatch [::logs-events/load-header-dashboard (:header @route-params)])]
    (let [header      (:header @route-params)
          header-ruid (str "/" header)
          qp          (select-keys @query-params [:page :activity])]
      (when (not= qp @last-qp)
        (reset! last-qp qp)
        (re-frame/dispatch [::logs-events/sync-header-query header @query-params]))
      [:<>
       [common/admin-top-bar]
       [common/navbar]
       [:<>
        [posts-logs-switch]
        [common/spinner]
        [:div
         {:class (css "container" {:width "auto !important"}) :id "page-body"}
         [breadcrumbs [header-ruid]]
         [:h1 [:code header-ruid] " " [:small "Header Dashboard"]]
         [header-btns header]
         [activity-btns header {:activities ["all" "post" "screen" "view" "admin"]}]
         [:div
          [:h2 (str (clojure.string/capitalize @(re-frame/subscribe [::logs-subs/activity])) " activity")]
          [pager]
          [activity-table]
          [pager]]]
                [common/message ::subs/message]]])))


(defn logs-post-panel []
  (r/with-let [route-params (re-frame/subscribe [::subs/route-params])
               query-params (re-frame/subscribe [::subs/query-params])
               last-qp      (r/atom nil)
               post         (re-frame/subscribe [::logs-subs/post-data])
               _            (re-frame/dispatch [::logs-events/load-post-dashboard (:id @route-params)])]
    (let [id (:id @route-params)
          qp (select-keys @query-params [:page :activity])]
      (when (not= qp @last-qp)
        (reset! last-qp qp)
        (re-frame/dispatch [::logs-events/sync-post-query id @query-params]))
      [:<>
       [common/admin-top-bar]
       [common/navbar]
       [:<>
        [posts-logs-switch]
        [common/spinner]
        [:div
         {:class (css "container" {:width "auto !important"}) :id "page-body"}
         [breadcrumbs (let [board  (:board @post)
                            thread (:thread @post)
                            nick   (:nick @post)]
                        (cond-> []
                          board  (conj [:a {:href (str "/logs" board)} board])
                          thread (conj [:a {:href (str "/logs/t/" (subs thread 1))} thread])
                          nick   (conj nick)))]
         [:h1 [:code (:ruid @post)] " " [:small "Post Dashboard"]]
         [:div
          [post-data]
          [post-actions]
          [activity-btns id]
          [:h2 (str (clojure.string/capitalize @(re-frame/subscribe [::logs-subs/activity])) " activity")]
          [pager]
          [activity-table]
          [pager]]]
                [common/message ::subs/message]]])))


(defn logs-thread-panel []
  (r/with-let [route-params (re-frame/subscribe [::subs/route-params])
               query-params (re-frame/subscribe [::subs/query-params])
               last-qp      (r/atom nil)
               _            (re-frame/dispatch [::logs-events/load-thread-dashboard (:id @route-params)])]
    (let [id          (:id @route-params)
          thread-ruid (str "+" id)
          ss          @(re-frame/subscribe [::posts-subs/screning-status thread-ruid])
          board       @(re-frame/subscribe [::logs-subs/panel-board])
          qp          (select-keys @query-params [:page :activity])]
      (when (not= qp @last-qp)
        (reset! last-qp qp)
        (re-frame/dispatch [::logs-events/sync-thread-query id @query-params]))
      [:<>
       [common/admin-top-bar]
       [common/navbar]
       [:<>
        [posts-logs-switch]
        [common/spinner]
        [:div
         {:class (css "container" {:width "auto !important"}) :id "page-body"}
         [breadcrumbs (cond-> []
                        board (conj [:a {:href (str "/logs" board)} board])
                        true  (conj thread-ruid))]
         [:h1 [:code thread-ruid] " " [:small "Thread Dashboard"]]
         [:div [screening-badge ss thread-ruid]]
         [activity-btns id {:activities ["all" "post" "view"]}]
         [:div
          [:h2 (str (clojure.string/capitalize @(re-frame/subscribe [::logs-subs/activity])) " activity")]
          [pager]
          [activity-table]
          [pager]]]
                [common/message ::subs/message]]])))


(defn logs-ip-panel []
  (r/with-let [route-params (re-frame/subscribe [::subs/route-params])
               query-params (re-frame/subscribe [::subs/query-params])
               last-qp      (r/atom nil)
               _            (re-frame/dispatch [::logs-events/load-ip-dashboard (:ip @route-params)])]
    (let [ip      (:ip @route-params)
          ip-ruid (str "^" ip)
          qp      (select-keys @query-params [:page :activity])]
      (when (not= qp @last-qp)
        (reset! last-qp qp)
        (re-frame/dispatch [::logs-events/sync-ip-query ip @query-params]))
      [:<>
       [common/admin-top-bar]
       [common/navbar]
       [:<>
        [posts-logs-switch]
        [common/spinner]
        [:div
         {:class (css "container" {:width "auto !important"}) :id "page-body"}
         [breadcrumbs ["IP" ip-ruid]]
         [:h1 [:code ip-ruid] " " [:small "IP Address Dashboard"]]
         [ip-btns ip]
         [activity-btns ip {:activities ["all" "post" "screen" "view" "admin"]}]
         [:div
          [:h2 (str (clojure.string/capitalize @(re-frame/subscribe [::logs-subs/activity])) " activity")]
          [pager]
          [activity-table]
          [pager]]]
                [common/message ::subs/message]]])))


(defn logs-eid-panel []
  (r/with-let [route-params (re-frame/subscribe [::subs/route-params])
               query-params (re-frame/subscribe [::subs/query-params])
               last-qp      (r/atom nil)
               _            (re-frame/dispatch [::logs-events/load-eid-dashboard (:eid @route-params)])]
    (let [eid      (:eid @route-params)
          raid-len @(re-frame/subscribe [::subs/raid-len])
          raid     (hench/eid-len-raid eid raid-len)
          qp       (select-keys @query-params [:page :activity])]
      (when (not= qp @last-qp)
        (reset! last-qp qp)
        (re-frame/dispatch [::logs-events/sync-eid-query eid @query-params]))
      [:<>
       [common/admin-top-bar]
       [common/navbar]
       [:<>
        [posts-logs-switch]
        [common/spinner]
        [:div
         [breadcrumbs ["EID" raid]]
         [:h1 [:code raid] " " [:small "EID Dashboard"]]
         [eid-btns eid]
         [activity-btns eid {:activities ["all" "post" "view"]}]
         [:div
          [:h2 (str (clojure.string/capitalize @(re-frame/subscribe [::logs-subs/activity])) " activity")]
          [pager]
          [activity-table]
          [pager]]]
                [common/message ::subs/message]]])))


(defn logs-user-panel []
  (r/with-let [route-params (re-frame/subscribe [::subs/route-params])
               query-params (re-frame/subscribe [::subs/query-params])
               last-qp      (r/atom nil)
               _            (re-frame/dispatch [::logs-events/load-user-dashboard (:user @route-params)])]
    (let [user      (:user @route-params)
          user-ruid (str "=" user)
          qp        (select-keys @query-params [:page :activity])]
      (when (not= qp @last-qp)
        (reset! last-qp qp)
        (re-frame/dispatch [::logs-events/sync-user-query user @query-params]))
      [:<>
       [common/admin-top-bar]
       [common/navbar]
       [:<>
        [posts-logs-switch]
        [common/spinner]
        [:div
         {:class (css "container" {:width "auto !important"}) :id "page-body"}
         [breadcrumbs ["User" user-ruid]]
         [:h1 [:code user-ruid] " " [:small "User Dashboard"]]
         [user-btns user]
         [activity-btns user {:activities ["all" "post" "screen" "view" "admin"]}]
         [:div
          [:h2 (str (clojure.string/capitalize @(re-frame/subscribe [::logs-subs/activity])) " activity")]
          [pager]
          [activity-table]
          [pager]]]
                [common/message ::subs/message]]])))

(defn logs-header-create-panel []
  [:div "logs header create panel"])

(defn logs-chosen-header-create-panel []
  [:div "logs chosen header create panel"])

(defn logs-chosen-header-edit-panel []
  [:div "logs chose header edit panel"])
